"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectUrl = exports.createFieldValuesObject = void 0;
// Takes in an array of field objects and returns a flat object where fieldName is the key and value is the value
var createFieldValuesObject = values => {
  return values === null || values === void 0 ? void 0 : values.reduce((acc, current) => {
    if (!(current !== null && current !== void 0 && current.fieldName) && current !== null && current !== void 0 && current.fields) {
      var nestedValues = createFieldValuesObject(current.fields);
      Object.assign(acc, nestedValues);
    } else {
      acc[current === null || current === void 0 ? void 0 : current.fieldName] = current === null || current === void 0 ? void 0 : current.value;
    }
    return acc;
  }, {});
};

// Constructs a URL by replacing placeholders in partialUrl with values from valuesObj if the key matches the placeholder
// partialUrl comes from postSubmissionMessage. Example: sandbox/test-page?firstName=${firstName}&lastName=${lastName}&lang=${lang}
exports.createFieldValuesObject = createFieldValuesObject;
var redirectUrl = (partialUrl, valuesObj) => {
  if (!(partialUrl !== null && partialUrl !== void 0 && partialUrl.includes('?'))) {
    return partialUrl;
  }
  var arr = partialUrl === null || partialUrl === void 0 ? void 0 : partialUrl.split(/(\${[^}]+})/);
  var regex = /\$\{[^}]*\}/;

  // Regex checks for placeholders in the form of ${placeholder} and replaces them with the value in valuesObj if it exists, otherwise replaces it with an empty string
  for (var i = 0; i < (arr === null || arr === void 0 ? void 0 : arr.length); i++) {
    if (regex !== null && regex !== void 0 && regex.test(arr[i])) {
      var _arr$i, _arr$i2;
      var placeHolder = (_arr$i = arr[i]) === null || _arr$i === void 0 ? void 0 : _arr$i.substring(2, ((_arr$i2 = arr[i]) === null || _arr$i2 === void 0 ? void 0 : _arr$i2.length) - 1);
      if (valuesObj[placeHolder]) {
        arr[i] = encodeURIComponent(valuesObj[placeHolder]);
      } else {
        arr[i] = '';
      }
    }
  }
  return arr === null || arr === void 0 ? void 0 : arr.join('');
};
exports.redirectUrl = redirectUrl;